import { values } from 'lodash-es';
import { DashboardCard, Http, SummaryData } from '../../../models/index';
import { CacheableResource } from '../CacheableResource';
import { GetResource } from '../GetResource';

export namespace GetSummaryData {
    export interface Params {
        card: DashboardCard;
        entityId: number;
        productionMode?: string;
        pricingStructure?: string;
    }
}

export class GetSummaryData {
    private getResource: GetResource<DashboardCard.Rel, SummaryData>;

    constructor(http: Http) {
        //super();
        this.getResource = new GetResource<DashboardCard.Rel, SummaryData>(http);
    }

    protected getId(params: GetSummaryData.Params): number {
        return params.card.id!;
    }

    execute({
        card,
        entityId,
        productionMode,
        pricingStructure
    }: GetSummaryData.Params): Promise<SummaryData> {
        let searchParams = {};
        if (this.isPortfolioCard(card)) {
            searchParams = { entityId, productionMode, pricingStructure };
        } else {
            searchParams = { entityId };
        }
        Object.keys(searchParams).forEach(
            (key) => searchParams[key] == null && delete searchParams[key]
        );

        return this.getResource
            .execute({
                parent: card,
                rel: 'summary-data',
                search: searchParams,
                useCache: false
            })
            .then((data: any) => {
                if (!Array.isArray(data)) {
                    // TODO: Remove this transformation once data cleanup is complete
                    return Object.keys(data).map((name) => {
                        return {
                            name,
                            dataStatus: data[name].dataStatus,
                            values: data[name].values /* istanbul ignore next */ || [],
                            level: data[name].level || 'days',
                            hidden: data[name].hidden || 'false',
                            dynamicGaugeThresholds: data[name].dynamicGaugeThresholds,
                            uom: data[name].uom
                        };
                    });
                } else {
                    return data;
                }
            });
    }

    private isPortfolioCard(value: any): value is DashboardCard {
        return value && value.card && value.card.portfolioFeatureSetId;
    }
}
